import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "button"]
  static values = {
    open: { type: Boolean, default: false }
  }

  connect() {
    this.closeHandler = this.closeOnClickOutside.bind(this)
  }

  disconnect() {
    document.removeEventListener("click", this.closeHandler)
  }

  toggle(event) {
    event.stopPropagation()
    this.openValue = !this.openValue
  }

  openValueChanged() {
    if (this.openValue) {
      this.menuTarget.classList.remove("hidden")
      this.buttonTarget.setAttribute("aria-expanded", "true")
      document.addEventListener("click", this.closeHandler)
    } else {
      this.menuTarget.classList.add("hidden")
      this.buttonTarget.setAttribute("aria-expanded", "false")
      document.removeEventListener("click", this.closeHandler)
    }
  }

  closeOnClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.openValue = false
    }
  }

  close() {
    this.openValue = false
  }
}
